// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d91da0e9","239":"17c96dae","453":"4174c8f3","732":"abc97814","762":"38075504","857":"d1ed794a"}[chunkId] + ".chunk.js";
};